module.exports = __webpack_public_path__ + "img/green3Dian5.1dc4001c.png";